import { EventEmitter, OnInit } from '@angular/core';
import { OrderOption } from '../../../model/order-option';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { PageNames } from '../../../shared/page-names.enum';
import { TvShopEntertainmentPack } from '../../../model/tv-shop-entertainment-pack';
import { PriceUtils } from '../../../shared/utils/price/price.utils';
import { LanguageService } from '../../../services/language/language.service';
import { ResourceService } from '../../../services/resource/resource.service';
import { Environment } from '../../../shared/environment/environment';
import { TvshopConstants } from '../../../shared/tvshop-constants';
import { OmapiIdConstants } from '../../../shared/omapi-id-constants';
var ProductOrderOptionComponent = /** @class */ (function () {
    function ProductOrderOptionComponent(navigationService, languageService, resourceService) {
        this.navigationService = navigationService;
        this.languageService = languageService;
        this.resourceService = resourceService;
        this.ownerComponent = PageNames.DETAIL_PAGE_ORDER_OPTIONS;
        this.emitOrderProduct = new EventEmitter();
        this.emitOrderTrial = new EventEmitter();
        this.label = 'eos-tv-shop-ii.title.play-sports-details-order-options-order';
    }
    ProductOrderOptionComponent.prototype.ngOnInit = function () {
        this.setLabel();
        this.priceDetail = this.orderOption ? this.orderOption.priceDetail : undefined;
    };
    ProductOrderOptionComponent.prototype.setLabel = function () {
        if (this.isDayPass) {
            this.label = 'eos-tv-shop-ii.title.play-sports-details-order-options-order-daypass';
        }
        else if (this.isTrial) {
            this.label = 'eos-tv-shop-ii.btn.trial-order';
        }
    };
    ProductOrderOptionComponent.prototype.getLogoUrl = function () {
        if (this.orderOption && !this.orderOption.isTrial) {
            return this.resourceService.getLogoUrl(this.orderOption.omapiId, undefined, this.orderOption.isDayPass);
        }
        else {
            return Environment.environmentConfig().baseUrl + TvshopConstants.IMAGES_AEM_PATH + OmapiIdConstants.TRIALS + '-logo.png';
        }
    };
    ProductOrderOptionComponent.prototype.activate = function (active) {
        this.active = active;
    };
    Object.defineProperty(ProductOrderOptionComponent.prototype, "hasPromo", {
        get: function () {
            return this.orderOption.priceDetail && this.orderOption.priceDetail.hasPromo();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductOrderOptionComponent.prototype, "hasPromoDayPass", {
        get: function () {
            return this.orderOption.priceDetail && this.orderOption.priceDetail.hasPromoLessThanAMonth();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductOrderOptionComponent.prototype, "isPromoSamePrice", {
        get: function () {
            return this.orderOption.priceDetail.price.value === this.orderOption.priceDetail.promoPrice.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductOrderOptionComponent.prototype, "promoLabel", {
        get: function () {
            return this.orderOption.priceDetail ? this.orderOption.priceDetail.promoLabel : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductOrderOptionComponent.prototype, "promoDuration", {
        get: function () {
            return this.orderOption.priceDetail ? this.orderOption.priceDetail.promoDuration : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductOrderOptionComponent.prototype, "textIntegerPart", {
        get: function () {
            return this.orderOption.priceDetail ? this.orderOption.priceDetail.price.integerPart() : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductOrderOptionComponent.prototype, "textDecimalPart", {
        get: function () {
            return this.getTextDecimalPart(this.orderOption.priceDetail ? this.orderOption.priceDetail.price.decimalPart() : undefined);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductOrderOptionComponent.prototype, "priceBeforeComma", {
        get: function () {
            return this.orderOption.priceDetail ? this.orderOption.priceDetail.promoPrice.integerPart() : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductOrderOptionComponent.prototype, "getPriceTextDecimalPart", {
        get: function () {
            return this.getTextDecimalPart(this.orderOption.priceDetail ? this.orderOption.priceDetail.promoPrice.decimalPart() : undefined);
        },
        enumerable: true,
        configurable: true
    });
    ProductOrderOptionComponent.prototype.onEmitOrderProduct = function (event) {
        this.emitOrderProduct.emit(event);
    };
    ProductOrderOptionComponent.prototype.onBack = function () {
        this.navigationService.resetPage();
    };
    Object.defineProperty(ProductOrderOptionComponent.prototype, "getCurrentLang", {
        get: function () {
            return this.languageService.getCurrentLanguage().toLowerCase();
        },
        enumerable: true,
        configurable: true
    });
    ProductOrderOptionComponent.prototype.onEmitOrderTrial = function ($event) {
        this.emitOrderTrial.emit(event);
    };
    Object.defineProperty(ProductOrderOptionComponent.prototype, "hideButton", {
        get: function () {
            return this.hasOverlayMessage && (this.isTrial || this.isDayPass);
        },
        enumerable: true,
        configurable: true
    });
    ProductOrderOptionComponent.prototype.getTextDecimalPart = function (price) {
        var sign = this.getCurrentLang === 'fr' ? ' €' : '';
        return PriceUtils.prefixDecimalPart(price, this.getCurrentLang) + sign;
    };
    return ProductOrderOptionComponent;
}());
export { ProductOrderOptionComponent };
